import { authHttp } from '../http'
import { errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'
import { parseToMysqlFormat } from '../../../util/date.service'
import { openReportInNewTab } from '../../../util/report.service'
import { getUsuarioInfo } from '../../../localstorage/localstorage.service'
import axios from 'axios'

const { ENVIROMENT } = CONFIG
const DOC_BASE_URL = `${CONFIG[ENVIROMENT]['DOCS_END_POINT']}`

const MovimentacaoLastMileHttp = {
  baseURL: `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/patrimonio`,

  async saveMovimentacao(movimentacao) {
    try {
      const url = this.baseURL + '/movimentacao-last-mile'
      const response = await authHttp().post(url, movimentacao)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async formInitInfo(tpId, user_id) {
    try {
      const url =
        this.baseURL + `/movimentacao-last-mile/form-init-info?tp_id=${tpId}&user_id=${user_id} `
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getMovimentacoesLastMile(dataInicial, dataFinal, tpsIds) {
    try {
      const pInicial = parseToMysqlFormat(dataInicial)
      const pFinal = parseToMysqlFormat(dataFinal)

      const url =
        this.baseURL +
        `/movimentacao-last-mile?pInicial=${pInicial}&pFinal=${pFinal}&tpsIds=${tpsIds.toString()}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  emitirComprovante(movimentacaoLastMileId) {
    const url =
      this.baseURL +
      `/movimentacao-last-mile/emitir-comprovante/${movimentacaoLastMileId}?t=${localStorage.getItem('t')}`
    openReportInNewTab(url)
  },

  emitirComprovantePrestacaoConta(prestacao_conta_id) {
    const url =
      this.baseURL +
      `/movimentacao-last-mile/prestacao-contas/emitir-comprovante/${prestacao_conta_id}?t=${localStorage.getItem('t')}`
    openReportInNewTab(url)
  },

  async saveNovaPrestacaoContas(prestacaoContas) {
    try {
      const user = getUsuarioInfo()
      const data_prestacao_contas = parseToMysqlFormat(prestacaoContas.data_prestacao_contas)
      const user_id = prestacaoContas.user_id ? prestacaoContas.user_id : user.id
      const url = this.baseURL + `/movimentacao-last-mile/prestacao-contas`
      const response = await authHttp().post(url, {
        ...prestacaoContas,
        data_prestacao_contas,
        user_id,
      })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getPrestacoesContas(movimentacaoLastMileId) {
    try {
      const url =
        this.baseURL + `/movimentacao-last-mile/prestacao-contas/${movimentacaoLastMileId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async apagarPrestacaoContas(prestacaoContasId) {
    try {
      const url = this.baseURL + `/movimentacao-last-mile/prestacao-contas/${prestacaoContasId}`
      await authHttp().delete(url)
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async addCanhoto(canhoto) {
    try {
      const url = this.baseURL + `/movimentacao-last-mile/prestacao-contas/canhoto`
      const response = await authHttp().post(url, canhoto)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deleteCanhoto(canhotoId) {
    try {
      const url = this.baseURL + `/movimentacao-last-mile/prestacao-contas/canhoto/${canhotoId}`
      await authHttp().delete(url)
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getCanhotosByStatus(tpsIds, status, dataInicial, dataFinal) {
    try {
      const encodedStatus = encodeURIComponent(JSON.stringify(status))
      const pInicial = parseToMysqlFormat(dataInicial)
      const pFinal = parseToMysqlFormat(dataFinal)
      const url =
        this.baseURL +
        `/movimentacao-last-mile/prestacao-contas/canhotos-by-status?tpsIds=${tpsIds.toString()}&status=${encodedStatus}&pInicial=${pInicial}&pFinal=${pFinal}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateCanhotosStatus(data) {
    try {
      const url = this.baseURL + `/movimentacao-last-mile/prestacao-contas/update-status/canhotos/`
      const response = await authHttp().put(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async importCanhotos(data, tp_id) {
    try {
      const url =
        this.baseURL +
        `/movimentacao-last-mile/prestacao-contas/update-status/canhotos/import/${tp_id}`
      const response = await authHttp().put(url, data)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async saveApuracaoFisica(items) {
    try {
      const url = this.baseURL + `/movimentacao-last-mile/prestacao-contas/apuracao-fisica`
      const response = await authHttp().post(url, items)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async getCanhotoById(canhotoId) {
    try {
      const url = this.baseURL + `/movimentacao-last-mile/prestacao-contas/canhoto/${canhotoId}`
      const response = await authHttp().get(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updatePathCanhoto(canhotoId, pathCanhoto) {
    try {
      const url =
        this.baseURL +
        `/movimentacao-last-mile/prestacao-contas/canhoto/update-path-canhoto/${canhotoId}`
      const response = await authHttp().put(url, { path_canhoto: pathCanhoto })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async deleteCanhotoFile(filename) {
    try {
      const url = `${DOC_BASE_URL}/patrimonio-canhoto/${filename}`
      const response = await axios.delete(url)
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  urlUploadCanhoto(canhotoId) {
    return `${DOC_BASE_URL}/patrimonio-canhoto/${canhotoId}`
  },

  async updateObservacao(canhotoId, observacao) {
    try {
      const url =
        this.baseURL +
        `/movimentacao-last-mile/prestacao-contas/canhoto/update-observacao/${canhotoId}`
      const response = await authHttp().put(url, { observacao })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },

  async updateClientId(canhotoId, clientId) {
    try {
      const url =
        this.baseURL +
        `/movimentacao-last-mile/prestacao-contas/canhoto/update-client-id/${canhotoId}`
      const response = await authHttp().put(url, { client_id: clientId ? clientId : null })
      return response.data
    } catch (error) {
      throw errorHandler(error)
    }
  },
}

export default MovimentacaoLastMileHttp
